import { render, staticRenderFns } from "./label.vue?vue&type=template&id=1ec49b3a"
import script from "./label.vue?vue&type=script&lang=js"
export * from "./label.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports